import script from "./Modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Modal.vue?vue&type=script&lang=ts&setup=true"

import "./Modal.vue?vue&type=style&index=0&id=1962266a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1962266a"]])

export default __exports__